const _require = require('lodash'),
  isPlainObject = _require.isPlainObject;
const _require2 = require('../lib/evaluateSource'),
  evaluateSource = _require2.evaluateSource;
const _require3 = require('../lib/common'),
  leafPedigreesString = _require3.leafPedigreesString;

/**
  * @function evalute - evaluate toStringBehavior
  */

const evaluate = async (source, content, parentContentPath, transientContext, nativeFunctions) => {
  const value = await evaluateSource(source.value, content, parentContentPath, transientContext, nativeFunctions);
  if (value === undefined || value === null) {
    return value;
  }
  if (isPlainObject(value)) {
    const title = value.title;
    if (title !== undefined) {
      return title;
    }
    return leafPedigreesString(value);
  }
  return value.toString();
};
module.exports = {
  evaluate
};